import { MoreVertical } from 'react-feather';
import { IconButton } from '@mui/material';
import { MouseEventHandler } from 'react';

const EntityRetryThreeDot = ({ onClick }: { onClick: MouseEventHandler<HTMLButtonElement> }) => {
  return (
    <IconButton onClick={onClick} size="small">
      <MoreVertical />
    </IconButton>
  );
};

export default EntityRetryThreeDot;
